<template>
    <div>
        <ValidationObserver ref="filterForm">
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('start_date')">
                        <select-date v-model="filter.date_greater_than" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('end_date')">
                        <select-date v-model="filter.date_smaller_than" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="filter.academic_year" :resultType="'code'"
                                :validate-error="errors[0]"
                            ></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="filter.faculty_code" ></faculty-selectbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('semester')">
                        <semester-type-selectbox v-model="filter.semester" ></semester-type-selectbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('report_type')">
                        <multi-selectbox
                            :allow-empty="false" :multiple="false"
                            :options="responseTypeOptions" v-model="responseType"
                        ></multi-selectbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-button variant="primary" @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import LecturerReportService from "@/services/LecturerReportService"
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import qs from 'qs'
import SemesterTypeSelectbox from "@/components/interactive-fields/SemesterTypeSelectbox.vue";

export default {
    components: {
        SemesterTypeSelectbox,
        SemestersSelectbox,
        FacultySelectbox,
        MultiSelectbox,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            filter: {},
            responseType: 'page',
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'}
            ]
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.filterForm.validate()

            if (isValid) {
                const config = {
                    params: {
                        filter: {
                            ...this.filter
                        },
                        response_type: this.responseType
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }


                if (this.responseType != 'page') {
                    config.responseType = 'arraybuffer'
                }

                LecturerReportService.getInstructorCourseLoadReport(config)
                    .then((response) => {
                        if(this.responseType == 'page') {
                            this._openFile(response)
                        }
                        else if(this.responseType == 'excel') {
                            this._downloadFile(response, 'instructor_course_load_report.xlsx')
                        }
                        else if(this.responseType == 'pdf') {
                            this._downloadFile(response, 'instructor_course_load_report.pdf')
                        }
                    })
                    .catch((error) => {
                        this.showErrors(error)
                    })
            }
        }
    }
}
</script>
